import { z } from 'zod'

/**
 * Every MCP tool the server can offer.
 *
 * The catalog in the API re-exports this. It is not a Prisma enum: a tool is
 * added in code, often, and a stored name from a tool that was later renamed
 * must not stop a deploy. Readers parse with {@link mcpToolNameSchema}, so a
 * name that is no longer offered fails that read instead.
 */
export const MCP_TOOL_NAMES = [
  'whoami',
  'list_venues',
  'find_events',
  'get_event',
  'get_event_furniture_availability',
  'list_venue_vendors',
  'search_vendors',
  'update_vendor_approvals',
  'list_furniture_catalog',
  'update_furniture_catalog',
  'get_my_company',
  'find_venues_to_serve',
  'update_my_company',
  'list_my_furniture',
  'update_my_furniture',
  'update_my_packages',
  'list_my_events',
  'get_my_event',
  'list_my_quote_requests',
  'list_my_reviews',
  'get_vendor_profile',
  'find_event_vendors',
  'set_guest_count',
  'get_plan_layout',
  'update_plan',
  'get_marketing_page',
  'update_marketing_page',
  'create_event',
  'update_event',
  'update_event_clients',
  'cancel_or_restore_event',
  'update_event_plans',
  'update_plan_details',
  'update_event_timeline',
  'update_event_furniture',
  'list_plan_versions',
  'restore_plan_version',
  'list_deleted_plans',
  'list_event_editors',
  'list_event_emails',
  'list_planners',
  'remove_event_company',
  'update_event_documents',
  'check_track_availability',
  'get_venue',
  'get_venue_lead_stats',
  'get_company_lead_stats',
  'get_venue_pipeline',
  'get_company_pipeline',
  'list_pipeline_couples',
  'find_leads',
  'create_venue',
  'update_venue',
  'update_venue_schedule',
  'update_venue_spaces',
  'update_venue_tracks',
  'list_saved_layouts',
  'update_saved_layouts',
  'update_timeline_templates',
  'get_venue_stock',
  'set_venue_stock',
  'list_timeline_templates',
  'apply_timeline_template',
] as const

export const mcpToolNameSchema = z.enum(MCP_TOOL_NAMES)

export type McpToolName = z.infer<typeof mcpToolNameSchema>
